/* Lili & Koi — Ember interactions. No dependencies. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var v = (cents / 100);
    var withDec = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return noDec;
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      return withDec;
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Scroll: burn line + hero ---------- */
  var root = document.documentElement;
  var hero = document.querySelector('.em-hero[data-scroll]');
  var rises = hero ? Array.prototype.slice.call(hero.querySelectorAll('[data-range]')) : [];
  var ticking = false;

  function onScroll() {
    ticking = false;
    var max = root.scrollHeight - window.innerHeight;
    var p = max > 0 ? clamp(window.scrollY / max) : 0;
    root.style.setProperty('--em-progress', p.toFixed(4));
    root.style.setProperty('--em-tip', p > 0.002 && p < 0.998 ? '1' : '0');

    if (hero && !reduce && window.innerWidth >= 1000) {
      var r = hero.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      var h = span > 0 ? clamp(-r.top / span) : 1;
      hero.style.setProperty('--em-hero', clamp(0.1 + h / 0.55).toFixed(3));
      rises.forEach(function (el) {
        var range = el.getAttribute('data-range').split(',');
        var a = parseFloat(range[0]), b = parseFloat(range[1]);
        el.style.setProperty('--o', clamp((h - a) / (b - a)).toFixed(3));
      });
    }
  }
  function requestTick() { if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); } }
  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', requestTick);
  onScroll();

  /* ---------- Reveal ---------- */
  var reveals = document.querySelectorAll('.em-reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    Array.prototype.forEach.call(reveals, function (el) { io.observe(el); });
  } else {
    Array.prototype.forEach.call(reveals, function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Mood tabs ---------- */
  function initMoods(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
    var select = function (id, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-mood') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
        if (on && focus) t.focus();
      });
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.getAttribute('data-mood')); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var next = tabs[(i + d + tabs.length) % tabs.length];
        select(next.getAttribute('data-mood'), true);
      });
    });
    section._emSelect = select;
    var hash = (location.hash || '').replace('#mood-', '');
    if (hash && section.querySelector('[data-mood="' + hash + '"]')) select(hash);
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-em-moods]'), initMoods);

  // Hero chips jump to a mood on the same page
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-mood-link]');
    if (!chip) return;
    var section = document.querySelector('[data-em-moods]');
    if (!section || !section._emSelect) return;
    e.preventDefault();
    section._emSelect(chip.getAttribute('data-mood-link'));
    section.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------- Mix & Match builder ---------- */
  function initMix(section) {
    var data;
    try { data = JSON.parse(section.querySelector('[data-em-mix-data]').textContent); } catch (err) { return; }
    var pct = data.percent / 100, min = data.min;
    var qty = {}, inBag = 0;
    var picks = Array.prototype.slice.call(section.querySelectorAll('[data-pick]'));
    var out = function (k) { return section.querySelector('[data-out="' + k + '"]'); };
    var btn = section.querySelector('[data-add]');
    var productIds = data.items.map(function (i) { return i.product_id; });

    data.items.forEach(function (i) { qty[i.variant_id] = 0; });

    function render() {
      var count = 0, sub = 0;
      data.items.forEach(function (i) { count += qty[i.variant_id]; sub += qty[i.variant_id] * i.price; });
      var unlocked = count + inBag >= min && count > 0;
      var save = unlocked ? Math.round(sub * pct) : 0;
      out('count').textContent = count;
      out('subtotal').textContent = money(sub);
      out('save').textContent = save ? '−' + money(save) : money(0);
      out('total').textContent = money(sub - save);
      var need = min - count - inBag;
      var msg;
      if (count === 0) msg = inBag ? data.text.inbag_zero.replace('[n]', inBag) : data.text.zero;
      else if (need > 0) msg = data.text.more.replace('[n]', need);
      else msg = data.text.unlocked;
      out('hint').textContent = msg;
      btn.disabled = count === 0;
      picks.forEach(function (p) {
        var id = p.getAttribute('data-pick');
        p.classList.toggle('is-on', qty[id] > 0);
        p.querySelector('[data-val]').textContent = qty[id];
        var dec = p.querySelector('[data-dec]');
        if (dec) dec.disabled = qty[id] === 0;
      });
    }

    picks.forEach(function (p) {
      var id = p.getAttribute('data-pick');
      var inc = p.querySelector('[data-inc]'), dec = p.querySelector('[data-dec]');
      if (inc) inc.addEventListener('click', function () { qty[id] = Math.min(9, qty[id] + 1); render(); });
      if (dec) dec.addEventListener('click', function () { qty[id] = Math.max(0, qty[id] - 1); render(); });
    });

    btn.addEventListener('click', function () {
      var items = Object.keys(qty).filter(function (k) { return qty[k] > 0; }).map(function (k) { return { id: parseInt(k, 10), quantity: qty[k] }; });
      if (!items.length) return;
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = data.text.adding;
      fetch((window.routes && window.routes.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'error'); });
        window.location.href = (window.routes && window.routes.cartUrl) || '/cart';
      }).catch(function (err) {
        btn.textContent = label; btn.disabled = false;
        out('hint').textContent = err.message && err.message !== 'error' ? err.message : data.text.error;
      });
    });

    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        inBag = cart.items.reduce(function (n, it) { return productIds.indexOf(it.product_id) > -1 ? n + it.quantity : n; }, 0);
        render();
      }).catch(function () {});

    render();
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-em-mix]'), initMix);

  /* ---------- Product page ---------- */
  function initPdp(section) {
    var slides = section.querySelectorAll('.em-pdp__slide');
    var thumbs = section.querySelectorAll('.em-pdp__thumb');
    Array.prototype.forEach.call(thumbs, function (t, i) {
      t.addEventListener('click', function () {
        Array.prototype.forEach.call(slides, function (s, j) { s.classList.toggle('is-on', i === j); s.setAttribute('aria-hidden', i === j ? 'false' : 'true'); });
        Array.prototype.forEach.call(thumbs, function (x, j) { x.setAttribute('aria-current', i === j ? 'true' : 'false'); });
      });
    });

    var form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var input = form.querySelector('[name="quantity"]');
    var val = form.querySelector('[data-val]');
    var btn = form.querySelector('[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    var variants = [];
    try { variants = JSON.parse(section.querySelector('[data-em-variants]').textContent); } catch (e) {}
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];

    function update() {
      var q = parseInt(input.value, 10) || 1;
      val.textContent = q;
      form.querySelector('[data-dec]').disabled = q <= 1;
      if (current) {
        var priceEl = section.querySelector('[data-price]');
        if (priceEl) priceEl.textContent = money(current.price);
        btn.disabled = !current.available;
        btn.textContent = current.available ? btn.getAttribute('data-label') + ' · ' + money(current.price * q) : btn.getAttribute('data-soldout');
      }
    }
    form.querySelector('[data-inc]').addEventListener('click', function () { input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1); update(); });
    form.querySelector('[data-dec]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); update(); });
    Array.prototype.forEach.call(form.querySelectorAll('[data-variant]'), function (r) {
      r.addEventListener('change', function () {
        current = variants.filter(function (v) { return String(v.id) === r.value; })[0];
        idInput.value = r.value;
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', r.value);
          window.history.replaceState({}, '', url.toString());
        }
        update();
      });
    });
    update();
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-em-pdp]'), initPdp);
})();
